const baseUrl = import.meta.env.VITE_API_BASE_URL

export const MEDICAL_EVENT_REGISTRATION = `${baseUrl}/medical-event`

export const MEDICAL_EVENT_REGISTRATION_FILTERED = (
  medical_event_id?: string
) => `${baseUrl}/medical-event/${medical_event_id}`
export const PATIENT_MEDICAL_EVENT_BASE = `${baseUrl}/patient-medical-event`

export const PATIENT_MEDICAL_EVENT_LIST = (patient_id: string) =>
  `${baseUrl}/patient-medical-event/patient/${patient_id}`

export const PATIENT_MEDICAL_EVENT_REGISTRATION_FILTERED = (
  medical_event_id?: string
) => `${baseUrl}/patient-medical-event/${medical_event_id}`
